import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import { ThreeUpLandScape } from './ThreeUpLandScape';
import { ThreeUpPortrait } from './ThreeUpPortrait';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_ThreeUp>;
};

export const ThreeUp = observer(function ThreeUp({ gridCard }: Props) {
  const { layout } = gridCard.data!.styles!;

  if (layout === 'landscape') {
    return <ThreeUpLandScape gridCard={gridCard} />;
  }

  return <ThreeUpPortrait gridCard={gridCard} />;
});
